import { combineReducers } from '@reduxjs/toolkit'

import { reducer as notification } from './notification'
import { reducer as app } from './app'
import { reducer as uploadProgress } from './uploadProgress'

export default combineReducers({ notification, app, uploadProgress })
